/** Fallback when Intl.supportedValuesOf is unavailable. */
export const FALLBACK_TIMEZONES = [
	'America/Edmonton',
	'America/Vancouver',
	'America/Winnipeg',
	'America/Toronto',
	'America/New_York',
	'America/Chicago',
	'America/Denver',
	'America/Los_Angeles',
	'America/Phoenix',
	'America/Anchorage',
	'Pacific/Honolulu',
	'UTC',
	'Europe/London',
	'Europe/Paris',
];

export function getTimezoneOptions() {
	try {
		if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
			return Intl.supportedValuesOf('timeZone').sort();
		}
	} catch (e) {
		// ignore
	}
	return FALLBACK_TIMEZONES;
}

export const DEFAULT_TIMEZONE = 'America/Edmonton';

/** Parse optional coordinate; returns null if empty/invalid. */
export function parseCoordinate(value, min, max) {
	if (value === '' || value == null || value === undefined) return null;
	const n = typeof value === 'number' ? value : parseFloat(String(value).trim());
	if (Number.isNaN(n) || n < min || n > max) return null;
	return n;
}

export function formatCoordinateInput(value) {
	if (value === '' || value == null || value === undefined) return '';
	return String(value);
}
